import React, { useRef, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import CSVReader from "react-csv-reader";
import classNames from "classnames";
import numural from "numeral";
import { format } from "date-fns";
import qs from "query-string";
import _ from "lodash";
import { EmitterStatus } from "../../event";

// COMPONENTS
import ContainerContent from "../Container/ContainerContent";
import LoadingPage from "../Loading/LoadingPage";
import LoadingMutation from "../Loading/LoadingMutation";
import BroadCastTable from "./BroadCastTable";

// HOOKS
import useBroadCastId from "../../hooks/useBroadCastId";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";
import AWS from "aws-sdk";

// UTILS
import { getCurrentLocalDateTime } from "../../utils/getLocalDateTime";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";

function BroadCastId() {
  const params = useParams();
  const history = useHistory();
  const router = useHistory();
  const {
    data,
    loading,
    error: errorData,
    getData,
  } = useBroadCastId({
    broadCastId: params.broadCastId,
  });
  const { user } = useSelector((state) => state.initializeApp);
  const [dataFiles, setDataFiles] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [form, setForm] = useState({
    title: "",
    description: "",
  });
  const [error, setError] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingBroadCast, setLoadingBroadCast] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [fileInfo, setFileInfo] = useState("");
  const [search, setSearch] = useState("");
  const [searchMin, setSearchMin] = useState("");
  const [count, setCount] = useState(0);
  const [countSend, setCountSend] = useState(0);
  const [countFail, setCountFail] = useState(0);

  const query = qs.parse(history.location.search);

  useEffect(() => {
    if (!data) return;

    setForm({ title: data.title, description: data.description });
  }, [data]);

  const importOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
  };

  const onField = async (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleUpdate = async () => {
    try {
      if (!form.title || !form.description) {
        setError(true);
        return;
      }

      setLoadingUpdate(true);
      await API.put("MoneyHubAdmin", `/broadcast/${data._id}`, {
        body: {
          title: form.title,
          description: form.description,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      setIsEdit(false);
      setLoadingUpdate(false);
      await getData();
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const handleExport = (importDatas, fileInfo) => {
    setDataFiles(importDatas);
    setFileInfo(fileInfo);
  };

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const onClickSubmitSearch = async () => {
    try {
      setLoadingSearch(true);
      let count = 0;
      let lastItem = null;
      let loans = [];

      do {
        const data = await API.get("MoneyHubAdmin", "/loan/loanLate", {
          queryStringParameters: {
            ExclusiveStartKey: getLastItem(lastItem),
            dueDate: search,
            minDueDate: searchMin,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = data?.lastItem;
        loans = [...loans, ...data?.loans];
        count += data?.loans?.length;
        setCount(count);
      } while (lastItem);

      // const mapLoans = loans.map((loan) => {
      //   return {
      //     phone_number: loan.phone_number,
      //     description: loan.description,
      //     name: loan.name,
      //     amount: numural(dataFile.amount).format("#00,00.00"),
      //     date: dataFile?.date
      //       ? format(new Date(dataFile.date), "dd-MM-yyyy")
      //       : format(new Date(), "dd-MM-yyyy"),
      //   }
      // })

      setDataFiles(loans);
    } catch (error) {
      console.log("submit search error", error);
    } finally {
      setLoadingSearch(false);
    }
  };

  const checkNextBroadCast = async () => {
    return new Promise(async (resvole, reject) => {
      setTimeout(() => {
        resvole(true);
      }, 1000);
    });
  };

  const handleBroadCast = async () => {
    try {
      setLoadingBroadCast(true);

      const convertType = query?.type === "debtor" ? "D" : "N";
      let countSuccess = 0;
      let countFail = 0;

      const firstFiles = [
        // {
        //   type: convertType,
        //   phone_number: "0877908161",
        //   name: "Non",
        //   lastname: "Non",
        //   totalDue: 0,
        //   duration: 0,
        //   amount: 0,
        //   date: "-",
        //   description: data.description,
        // },
        // {
        //   type: convertType,
        //   phone_number: "0867761082",
        //   name: "A",
        //   lastname: "A",
        //   totalDue: 0,
        //   duration: 0,
        //   amount: 0,
        //   date: "-",
        //   description: data.description,
        // },
        {
          type: convertType,
          phone_number: "0639179222",
          name: "Game",
          lastname: "Game",
          totalDue: 0,
          duration: 0,
          amount: 0,
          date: "-",
          description: data.description,
        },
        {
          type: convertType,
          phone_number: "0845293955",
          name: "Kim",
          lastname: "Kim",
          totalDue: 0,
          duration: 0,
          amount: 0,
          date: "-",
          description: data.description,
        },
      ];

      let localChunkDataFiles = _.cloneDeep(
        _.chunk([...firstFiles, ...dataFiles], 50)
      );

      for (let index = 0; index < localChunkDataFiles.length; index++) {
        const localChunkDataFile = localChunkDataFiles[index];
        for (let jedex = 0; jedex < localChunkDataFile.length; jedex++) {
          const dataFile = localChunkDataFile[jedex];

          if (query?.type === "normal") {
            const dataNoti = await API.post(
              "MoneyHubAdmin",
              `/broadcast/notify`,
              {
                body: {
                  type: convertType,
                  phone_number: dataFile.phone_number,
                  description: data.description,
                  name: dataFile.name,
                  amount: numural(dataFile.amount).format("#00,00.00"),
                  date: dataFile?.date !== "-" && dataFile?.date
                    ? format(new Date(dataFile.date), "dd-MM-yyyy")
                    : format(new Date(), "dd-MM-yyyy"),
                },
              }
            );
            if (dataNoti?.type === "S") {
              countSuccess++;
            } else {
              countFail++;
            }
          } else {
            if (typeof dataFile.phone_number === "string") {
              dataFile.phone_number = dataFile?.phone_number.slice(
                1,
                String(dataFile?.phone_number).length
              );
            }

            const dataNoti = await API.post(
              "MoneyHubAdmin",
              `/broadcast/notify`,
              {
                body: {
                  type: convertType,
                  phone_number: dataFile.phone_number,
                  description: data.description,
                  name: dataFile.name,
                  lastname: dataFile.lastname,
                  totalDue: numural(dataFile.totalDue).format("#00,00.00"),
                  duration: dataFile?.duration,
                },
              }
            );
            if (dataNoti?.type === "S") {
              countSuccess++;
            } else {
              countFail++;
            }
          }
          setCountSend((prev) => prev + 1);
        }

        const checkTimeout = await checkNextBroadCast();
        if (checkTimeout) {
          console.log("next chunk", index);
        }
      }

      // for (let dataFile of localDataFiles) {
      //   console.log("data", data);
      //   console.log("dataFile", dataFile);
      //   const convertType = query?.type === "debtor" ? "D" : "N";

      //   if (query?.type === "normal") {
      //     await API.post("MoneyHubAdmin", `/broadcast/notify`, {
      //       body: {
      //         type: convertType,
      //         phone_number: dataFile.phone_number,
      //         description: data.description,
      //         name: dataFile.name,
      //         amount: numural(dataFile.amount).format("#00,00.00"),
      //         date: dataFile?.date
      //           ? format(new Date(dataFile.date), "dd-MM-yyyy")
      //           : format(new Date(), "dd-MM-yyyy"),
      //       },
      //     });
      //   } else {
      //     if (typeof dataFile.phone_number === "string") {
      //       dataFile.phone_number = dataFile?.phone_number.slice(
      //         1,
      //         String(dataFile?.phone_number).length
      //       );
      //     }

      //     await API.post("MoneyHubAdmin", `/broadcast/notify`, {
      //       body: {
      //         type: convertType,
      //         phone_number: dataFile.phone_number,
      //         description: data.description,
      //         name: dataFile.name,
      //         lastname: dataFile.lastname,
      //         totalDue: numural(dataFile.totalDue).format("#00,00.00"),
      //         duration: dataFile?.duration,
      //       },
      //     });
      //   }
      // }
      await API.post("MoneyHubAdmin", `/fileExcel/historySync`, {
        body: {
          username: user.username,
          function_name: "BROADCAST",
          fileName: fileInfo.name,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await EmitterStatus("SUCCESS", {
        text: `S: ${countSuccess}, F: ${countFail}`,
      });
    } catch (error) {
      console.log("handleBroadCast", error);
    } finally {
      setLoadingBroadCast(false);
    }
  };

  const onDeleteBroadCast = async () => {
    try {
      setLoadingUpdate(true);
      await API.del("MoneyHubAdmin", `/broadcast/${data._id}`, {
        body: {
          title: form.title,
          description: form.description,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      setLoadingUpdate(false);
      router.goBack();
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  if (errorData) {
    return <ContainerContent>{errorData}</ContainerContent>;
  }
  const notify = () => toast("ข้อมูลของคุณพร้อมแล้ว!");
  return (
    <ContainerContent>
      <div className="w-full px-4 py-4 relative overflow-hidden">
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="flex flex-row  justify-between">
          <div
            className="border-gray-800  rounded text-gray-700 hover:text-gray-900 outline-none cursor-pointer  ring-0   mr-10 "
            onClick={() => router.goBack()}
          >
            <svg
              className="w-6 h-6"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          {/* {query?.type !== "debtor" && ( */}
          <CSVReader
            parserOptions={importOptions}
            onFileLoaded={handleExport}
          ></CSVReader>
          {/* )} */}
          {loadingBroadCast ? (
            <button
              className="flex items-center space-x-1"
              disabled
              onClick={handleBroadCast}
            >
              <LoadingMutation text={countSend} />
            </button>
          ) : (
            <button
              disabled={!dataFiles.length}
              onClick={handleBroadCast}
              className={classNames(
                "border p-1 px-2 rounded  duration-300 hover:text-white ",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !dataFiles.length,
                  "border-green-500 p-1 px-2 rounded text-green-500 hover:bg-green-600 hover:text-white":
                    dataFiles.length,
                }
              )}
            >
              {countSend} BroadCast
            </button>
          )}
        </div>
      </div>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="py-2 w-full ">
          <div className="max-w-sm h-full rounded overflow-hidden  border border-gray-200 mx-auto my-4 p-2">
            <h2 className="font-bold text-lg">คู่มือวิธีการใช้งาน</h2>
            <p>
              1.ใส่เครื่องหมาย {"${variable}"} variable จะเป็นตัวแปรที่เราจะใส่
              เช่น {query?.type === "debtor" ? "${totalDue}" : "${amount}"}
            </p>
            {query?.type === "debtor" ? (
              <React.Fragment>
                <p>phone_number = เบอร์โทรศัพท์</p>
                <p>totalDue = ยอดคงค้างทั้งหมด</p>
                <p>lastname = นามสกุล</p>
                <p>name = ชื่อ</p>
                <p>duration = วัน</p>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <p>phone_number = เบอร์โทรศัพท์</p>
                <p>amount = ยอดเงิน</p>
                <p>date = วันที่</p>
                <p>name = ชื่อ</p>
              </React.Fragment>
            )}
          </div>
          <div className="max-w-sm h-full rounded overflow-hidden  border border-gray-200 mx-auto">
            <div className="p-4">
              <div className="text-base mb-2">
                {isEdit ? (
                  <React.Fragment>
                    <label>หัวข้อ</label>
                    <input
                      className="block border border-grey-light w-full p-2 rounded"
                      type="text"
                      name="title"
                      onChange={onField}
                      value={form.title}
                      defaultValue={data.title}
                    />
                    {error && !form.title && (
                      <span className="text-sm text-red-500">
                        โปรดกรอกหัวข้อ
                      </span>
                    )}
                  </React.Fragment>
                ) : (
                  data.title
                )}
              </div>
              <p className="text-gray-700 text-base">
                {isEdit ? (
                  <React.Fragment>
                    <label>เนื้อหา</label>
                    <textarea
                      rows="4"
                      className="block border border-grey-light w-full p-3 rounded"
                      type="text"
                      name="description"
                      onChange={onField}
                      value={form.description}
                      defaultValue={data.description}
                    />
                    {error && !form.description && (
                      <span className="text-sm text-red-500">
                        โปรดกรอกรายละเอียด
                      </span>
                    )}
                  </React.Fragment>
                ) : (
                  data.description
                )}
              </p>
            </div>
            <div className="p-2 pt-0">
              {isEdit ? (
                <React.Fragment>
                  {loadingUpdate ? (
                    <button onClick={handleUpdate}>
                      <LoadingMutation />
                    </button>
                  ) : (
                    <div className="px-2">
                      <button
                        onClick={handleUpdate}
                        className={classNames(
                          " border w-full mb-1 duration-300  border-green-500 p-1 px-2 rounded text-green-500 hover:bg-green-600 hover:text-white"
                        )}
                      >
                        บันทึก
                      </button>
                      <button
                        onClick={() => setIsEdit(false)}
                        className={classNames(
                          " duration-300  p-1 px-2 w-full rounded text-red-500 hover:bg-red-600 hover:text-white"
                        )}
                      >
                        ยกเลิก
                      </button>
                    </div>
                  )}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {loadingUpdate ? (
                    <button disabled>
                      <LoadingMutation />
                    </button>
                  ) : (
                    <React.Fragment>
                      <button
                        onClick={() => setIsEdit(true)}
                        className="w-full duration-300 bg-transparent hover:bg-green-500 text-green-500 font-semibold hover:text-white py-2 px-4 border border-green-500 hover:border-transparent rounded"
                      >
                        แก้ไขข้อความ
                      </button>
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      )}
      {query?.type === "debtor" && (
        <div className="flex mb-2 items-center w-full">
          <div className="text-bold mr-2 ml-4">ดึงข้อมูลตามวัน</div>
          <div className="flex space-x-1 items-center">
            <input
              className="block border border-grey-light w-16 px-2 py-1 rounded"
              type="number"
              name="min"
              placeholder="1"
              onChange={(e) => setSearchMin(e.target.value)}
              value={searchMin}
              // onChange={onField}
              // value={form.title}
              // defaultValue={data.title}
            />
            <input
              className="block border border-grey-light w-16 px-2 py-1 rounded"
              type="number"
              name="max"
              placeholder="90"
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              // onChange={onField}
              // value={form.title}
              // defaultValue={data.title}
            />
            <div>วัน</div>
          </div>
          <button
            disabled={loadingSearch || !search.length}
            onClick={onClickSubmitSearch}
            className={classNames(
              " duration-300 flex items-center bg-transparent text-white font-semibold hover:text-white py-1 px-2 rounded ml-2",
              {
                "hover:bg-green-600 bg-green-500 cursor-pointer w-20":
                  !loadingSearch && search.length > 0,
                "bg-gray-300 col-auto": loadingSearch || !search.length,
              }
            )}
          >
            {loadingSearch && (
              <svg
                className="animate-spin -ml-1 mr-2 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx={12}
                  cy={12}
                  r={10}
                  stroke="currentColor"
                  strokeWidth={4}
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            )}
            <div className="mr-1">{loadingSearch && count}</div>
            <div className="text-center">ยืนยัน</div>
          </button>
        </div>
      )}
      <div>
        {query?.type === "debtor" && <div className="ml-4">จำนวน {count}</div>}
        <BroadCastTable data={dataFiles.slice(0, 250)} query={query} />
      </div>
    </ContainerContent>
  );
}

export default BroadCastId;
